<a [routerLink]="['..']" class="adap-link link-return">
  <mat-icon svgIcon="cvx-left"></mat-icon>
  global settings
</a>

<ng-container>
  <button class="adap-btn-outline clear-button" (click)="clearAllFilters()">
    clear all filters
  </button>

  <div class="tables-container">
    <div class="assignments-container">
      <div class="table-title-container">
        <div class="table-title">assignments</div>
      </div>

      <app-assignments-contacts-table
        *ngIf="assignments.length > 0; else assignmentPlaceholder"
        [rowData]="assignments"
        (filterByUserRole)="onFilterByUserRole($event)"
      >
      </app-assignments-contacts-table>

      <ng-template #assignmentPlaceholder>
        <div class="assignment-placeholder">
          <app-placeholder
            icon="assets/images/no-systems.svg"
            title="no assignments found"
            description="add assignments to phases"
          >
          </app-placeholder>
        </div>
      </ng-template>
    </div>

    <div class="phases-container">
      <div class="table-title-container">
        <div class="table-title">phases</div>
      </div>

      <app-assignments-phases-table
        *ngIf="phases.length > 0; else phasePlaceholder"
        [rowData]="phases"
        (filterByProjectPhase)="onFilterByProjectPhase($event)"
      >
      </app-assignments-phases-table>

      <ng-template #phasePlaceholder>
        <div class="phase-placeholder">
          <app-placeholder
            icon="assets/images/no-systems.svg"
            title="no phases created yet"
            description="create phases for projects"
          >
          </app-placeholder>
        </div>
      </ng-template>
    </div>
  </div>
</ng-container>
